import { useContext } from "react";
// @ts-expect-error -- untyped module
import mfaAddEmail from "@/assets/mfa-add-email.svg";

import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
// import {  MfaViewState } from "@/pages/containers/mfa-container";
import { InputWithLabel } from "../input-label";
import { useForm } from "@tanstack/react-form";
import useUserInfo from "@/hooks/use-user-info";
import { registerPageSchema } from "@/lib/form-schema";
import { MFAContext, MfaViewState } from "@/context/mfa-provider";

const MfaAddEmail = () => {
  const { setViewState, setEmail } = useContext(MFAContext);
  const userInfo = useUserInfo();

  const form = useForm({
    defaultValues: {
      email: userInfo.email ? userInfo.email : null,
    },
    onSubmit: ({ value }) => {
      setEmail(value.email);
      setViewState(MfaViewState.REQUEST_OTP);
    },
  });

  return (
    <form
      className="flex flex-col justify-between gap-8 text-center sm:w-auto lg:w-[260px]"
      onSubmit={(e) => {
        e.preventDefault();
        e.stopPropagation();
        form.handleSubmit();
      }}
    >
      <div className="grid h-full grid-cols-1 place-items-center gap-6">
        <img src={mfaAddEmail} className="size-20" alt="" />
        <Label className="text-lg font-bold">Add Your Email</Label>
        <div className="flex flex-col gap-1 text-center">
          <Label className="text-sm/6">
            We need your email to setup Multi Factor Authentication
          </Label>
        </div>
        <div className="grid w-full max-w-sm items-center gap-3 text-left">
          <form.Field
            name="email"
            validators={{
              onBlur: ({ value }) => {
                const result = registerPageSchema.shape.email.safeParse(value);
                return result.success
                  ? undefined
                  : result.error.errors[0].message;
              },
            }}
          >
            {(field) => (
              <div className="flex flex-row items-center space-x-2">
                <InputWithLabel
                  id="email"
                  label="Email Address"
                  placeholder="Email Address"
                  value={field.state.value}
                  onChange={(newValue) => field.handleChange(newValue)}
                  onBlur={() => field.handleBlur()}
                  error={field.state.meta.errors[0]}
                />
              </div>
            )}
          </form.Field>
        </div>
      </div>
      <div className="flex justify-center gap-4">
        <form.Subscribe selector={(state) => [state.canSubmit]}>
          {([canSubmit]) => (
            <Button
              className="w-full bg-blue-600 hover:bg-blue-800"
              type="submit"
              disabled={!canSubmit}
            >
              Use Email
            </Button>
          )}
        </form.Subscribe>
      </div>
    </form>
  );
};

export default MfaAddEmail;
